import { AccountingBook } from "./accounting-book";
import { JournalEntryDetail } from "./journal-entry-detail";
import { SystemField } from "./system-field";

export class JournalEntry extends SystemField{
    module?:string;
    batch_number?:string;
    fin_period?:string;
    transaction_date?:string;
    orig_gl_id?:string;
    is_reverse?:number=0;
    status?:string;
    comments?:string;
    note?:string;
    ledger_id?:string;
    cash_transfer_id?:string;
    released_date?:string;
    branch_id?:string;
    total_credit?:number=0;
    total_debit?:number=0;
    original_batch_id?:string;
    cash_transaction?:any;
 
    //relationship
    journal_detail?:JournalEntryDetail;
    accounting_book?:AccountingBook;
}
